import { render } from "./WhyChoose.vue?vue&type=template&id=491acecc&scoped=true"
import script from "./WhyChoose.vue?vue&type=script&lang=js"
export * from "./WhyChoose.vue?vue&type=script&lang=js"

import "./WhyChoose.vue?vue&type=style&index=0&id=491acecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491acecc"]])

export default __exports__